import React, { useState, useEffect } from 'react';
import { Facebook, Instagram, MessageCircle } from 'lucide-react';

const SocialFloatingBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const socials = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/p/SDORA-Wellbeing-LLC-100086663974006/',
      icon: Facebook,
      bg: 'bg-[#1877F2]',
      hover: 'hover:bg-[#0d65d9]'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/sdorawellbeing/',
      icon: Instagram,
      bg: 'bg-gradient-to-br from-[#f9ce34] via-[#ee2a7b] to-[#6228d7]',
      hover: 'hover:opacity-90'
    },
    {
      name: 'Call Us',
      url: 'tel:+18777725150',
      icon: MessageCircle,
      bg: 'bg-green-600',
      hover: 'hover:bg-green-700'
    }
  ];

  return (
    <div
      className={`fixed left-0 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-1.5 transition-all duration-500 ${
        visible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
      }`}
      data-testid="social-floating-bar"
    >
      {socials.map((s) => (
        <a
          key={s.name}
          href={s.url}
          target={s.url.startsWith('tel') ? '_self' : '_blank'}
          rel="noopener noreferrer"
          aria-label={s.name}
          className={`flex items-center gap-2 ${s.bg} ${s.hover} text-white pl-3 pr-4 py-2.5 rounded-r-lg shadow-lg transition-all duration-200 group`}
          data-testid={`social-float-${s.name.toLowerCase().replace(/\s/g, '-')}`}
        >
          <s.icon className="w-5 h-5" />
          <span className="text-xs font-semibold hidden group-hover:inline whitespace-nowrap">{s.name}</span>
        </a>
      ))}
    </div>
  );
};

export default SocialFloatingBar;
